import React, {useEffect, useState} from 'react';
import PropTypes from "prop-types";

function NumericValueField({initial, callback, min = null, max = null, precision = 0}) {
    const [value, setValue] = useState(initial !== null && initial !== undefined ? initial.toString() : '');

    useEffect(() => {
        setValue(initial !== null && initial !== undefined ? initial.toString() : '');

        return () => setValue('');
    }, [initial]);

    function renderError() {
        if (value === '') {
            return null;
        }

        if (!isValid(value)) {
            if (precision === 0) {
                return (
                    <div className='text-danger text-sm-left'>Invalid value. Must be a whole integer number.</div>
                );
            } else {
                return (
                    <div className='text-danger text-sm-left'>Invalid value. Must be a decimal number
                        with {precision} decimal place(s).</div>
                );
            }
        }

        return null;
    }

    function renderMinError() {
        if (value === '') {
            return null;
        }

        if (min !== null && parseFloat(value) < min) {
            return (
                <div className='text-danger text-sm-left'>Value is not in range. Must be more or equal to {min}</div>
            );
        }

        return null;
    }

    function renderMaxError() {
        if (value === '') {
            return null;
        }

        if (min !== null && parseFloat(value) > max) {
            return (
                <div className='text-danger text-sm-left'>Value is not in range. Must be less or equal to {max}</div>
            );
        }

        return null;
    }

    function isValid(value) {
        if (value.length <= 0) {
            return false;
        }

        return !isNaN(parseFloat(value)) && parseFloat(value).toFixed(precision) === value.toString();
    }

    return (
        <>
            <input
                value={value}
                className='form-control'
                onChange={event => {
                    const val = event.target.value;
                    setValue(val);
                    if (val === '') {
                        callback(null);
                    } else if (isValid(val)) {
                        callback(parseFloat(val));
                    }
                }}/>
            {renderError()}
            {renderMinError()}
            {renderMaxError()}
        </>
    );
}

NumericValueField.propTypes = {
    initial: PropTypes.number,
    min: PropTypes.number,
    max: PropTypes.number,
    precision: PropTypes.number,
    callback: PropTypes.func.isRequired
}

export default NumericValueField;
